import type { LinkProps } from "@packages/framework";

import { URL_COPYRIGHT } from "../../constants/urls/urlCopyright";
import { URL_PRIVACY_POLICY } from "../../constants/urls/urlPrivacyPolicy";
import { URL_TERMS_OF_SERVICE } from "../../constants/urls/urlTermsOfService";

export const LINKS = {
  web_copyright: {
    message: "web_copyright",
    props: {
      href: URL_COPYRIGHT,
      target: "_blank",
    },
  },
  web_privacy_policy: {
    message: "web_privacy_policy",
    props: {
      href: URL_PRIVACY_POLICY,
      target: "_blank",
    },
  },
  web_terms_of_service: {
    message: "web_terms_of_service",
    props: {
      href: URL_TERMS_OF_SERVICE,
      target: "_blank",
    },
  },
} as const satisfies Record<string, { message: string; props: LinkProps }>;
